module.exports = __webpack_public_path__ + "img/drmartens_jadon-black.0b73cd38.png";